module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-cyrillic-ext12.ea48f4f.woff2";